import '../../vendor/printThis.js'
import { bake_cookie, eraseCookie, setCookie } from './cookie.js'
import { loading } from '../components/loading.js'
import { saveInfoToCookie } from '../components/save-info-to-cookie.js'
// import Swal from 'sweetalert2'
// import { swalOption } from '../components/swal-opt'
import { _query } from './query.js'
import removeTicketFromCart, { removeGiftCardFromCart } from './removeTicketFromCart.js'
import { isMobileDevice } from './base-init.js'
import CustomTooltip from "./custom-tooltip.ts";

window.viewedOuibounceModal = false
window.disabledOuibounce = false
const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
let voucherIsValid

window.num = void 0

export function emptyCartNum(schedPage, eventPage) {
	return addLoadingEffect().then(() => {
		var nextURL = getNavigationURL(schedPage, eventPage)

		$.post('/store/shopping-cart/remove-all-clear-patron/', () => {
			$('#mobile-header-timer-seating-chart').TimeCircles().stop()
			window.location.href = '/' + nextURL
		})
	})
}

export function emptyCartNum2025(baseSlug, schedule, choice, saveInfo) {
	return addLoadingEffect().then(() => {
		var nextURL = getNavigationURL2025(baseSlug, schedule, choice, saveInfo)

		$.post('/store/shopping-cart/remove-all-clear-patron/', () => {
			$('#mobile-header-timer-seating-chart').TimeCircles().stop()
			window.location.href = '/' + nextURL
		})
	})
}

export function emptyCartSimple(callback) {
	$.post('/store/shopping-cart/remove-all/', () => {
		if (callback) {
			callback()
		}
	})
}

export function emptyCartTickets(callback) {
	// $('#icon-shoppingcart-num').html(0)

	$.post('/store/shopping-cart/remove-tickets/', () => {
		if (callback) {
			callback()
		}
	})
}

export function cartLoadJsonOrderSummary() {
	return new Promise((resolve, reject) => {
		$('#review-cart-summary').html(
			'<div class="progress"><div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div></div>'
		)
		const jsonUrl = '/store/order/ajax-cart-load-order-summary/json/1'

		$.ajax({
			url: jsonUrl,
			dataType: 'json',
			success (payload) {
				console.debug(eval(payload.amount))
				console.debug(typeof eval(payload))
				const meta = eval(payload.amount.meta)
				const { finalTotal, quantityTotal } = meta
				$('#cart-header-label').append(`
				<figure class='img-center'>
				${finalTotal}
				<span>${quantityTotal}</span>
					</figure>`)
			},
			error (err) {
				// Token expired or unexpected error, clean up session storage
				console.error(err)
			},
		})
	})
}

export function setStyles() {
	const stylelists = document.querySelectorAll('.seats-found-img-wrapper')
	const stylelistsLength = stylelists.length

	for (let i = 0; i < stylelistsLength; i++) {
		stylelists[i].style.setProperty(
			'--aspect-ratio',
			(window.chartVars.chartHeight + window.canvasPadding * 2) /
			(window.chartVars.chartWidth + window.canvasPadding * 2)
		)
		stylelists[i].style.setProperty(
			'--aspect-ratio-mobile',
			(window.chartVars.chartHeight + window.canvasPadding * 2) /
			(window.chartVars.chartWidth + window.canvasPadding * 2)
		)
		$(stylelists[i])
			.find('.AspectRatio')
			.css(
				'padding-bottom',
				((window.chartVars.chartWidth + window.canvasPadding * 2) /
					(window.chartVars.chartHeight + window.canvasPadding * 2)) *
				100 + '%'
			)
	}
}

export function cartLoadOrderSummary() {
	return new Promise((resolve, reject) => {
		$('#review-cart-summary').html(loading(2, 1.4))
		$('#review-cart-summary-desk').html(loading(2, 1.4))

		const ajaxUrl = '/store/order/ajax-cart-load-order-summary/cart/1'

		$.ajax({
			url: ajaxUrl,
			type: 'GET',
			success (payload) {
				const cartMessageData = $(payload).filter('.seat-message-block')

				$('.seat-message-block-placeholder').html(cartMessageData)
				// console.info(`cartSummaryData: ${cartSummaryData}`)

				// const cartSummaryData = $(payload).filter(
				//   '.order-general-right-column-section[data-order-summary]'
				// // )
				// const totalAmt = $(payload).find('.order-general-order-summary-value')
				// if (/[123456789]/g.test(totalAmt.html())) {
				// 	//if there is an non zero number in there, it means the total is more than $0
				// 	$('.secure-checkout-btn .btn__content').html(window.myvars.next)
				// }

				$('#review-cart-summary').html(payload)
				addCustomTooltip();
				resolve()
			},
			error (err) {
				console.error(err)
				reject(err)
			},
		})
	})
}

export function addCustomTooltip() {
	const tooltips = ['facilityFeeTooltip', 'orderProcessingFeeTooltip', 'ticketingFeeTooltip', 'taxTooltip'];
	if (typeof window.tooltip === 'undefined') {
		window.tooltip = new CustomTooltip();
	}

	$.each(tooltips, function(_, name) {
		if ($(`.${name}`).length > 0) {
			document.querySelectorAll(`.${name}`).forEach(function(el) {
				el.append(createElementFromHTML(window.tooltip.createInfoIcon(myvars[name])));
			});
		}
	});
	window.tooltip.attachAll();
}

export function addCustomTooltipOnce() {
	const tooltips = ['holdSeatsTip'];
	if (typeof window.tooltip === 'undefined') {
		window.tooltip = new CustomTooltip();
	}
	$.each(tooltips, function(_, name) {
		if ($(`.${name}`).length > 0) {
			document.querySelectorAll(`.${name}`).forEach(function(el) {
				el.append(createElementFromHTML(window.tooltip.createInfoIcon(myvars[name])));
			});
		}
	});
	window.tooltip.attachAll();
}


function createElementFromHTML(htmlString) {
	const div = document.createElement('div');
	div.innerHTML = htmlString.trim();

	// Change this to div.childNodes to support multiple top-level nodes.
	return div.firstChild;
}

function copyMobileDataToDesktop() {
	return new Promise((resolve, _) => {
		const mobileData = $('#review-cart-summary')
			.find('.order-general-right-column-section[data-order-summary]')
			.html()

		$('#review-cart-summary-desk').html(mobileData)
		resolve()
	})
}

function updatePaymentMethods() {
	if (
		$('#final-total-amount').length &&
		$('#final-total-amount').text() === '0'
	) {
		const checkoutBtn =
			'<div class="review-cart-btns" id="review-cart-btns-nopayment"><a data-value="secure-checkout" href="/store/order/fast-payment" class="secure-checkout-btn btn btn-primary overlay-btn col-w-100 no-barba data-page-track-cart">' +
			window.myvars.secureCheckout +
			'<svg class="icon-svg icon-svg--size-18 btn__spinner icon-svg--spinner-button" aria-hidden="true" focusable="false"> <use xlink:href="#spinner-button"></use></svg></a></div>'
		$('#review-cart-btns-payment').hide()
		$('#paypal-button-container-mobile').hide()
		$('.reviewCart__btns__Wrapper').append(checkoutBtn)
	} else {
		$('#review-cart-btns-payment').show()
		$('#paypal-button-container-mobile').show()
		$('#review-cart-btns-nopayment').remove()
	}
}

export async function getCartData() {
	try {
		await cartLoadOrderSummary()
		copyMobileDataToDesktop()
		updatePaymentMethods()
	} catch (error) { }
}

export async function cartExpandTrigger() {
	try {
		await cartLoadOrderSummary()
		copyMobileDataToDesktop()
		updatePaymentMethods()
		// openFeeDetailsCollapse()
	} catch (error) {
		console.info(`cartExpandTrigger error: ${error}`)
	}
}

export function openFeeDetailsCollapse() {
	if (window.innerWidth > 768) {
		$('.fee-details-collapse').collapse('show')
	}
}

export function upatePhoneLink() {
	const phoneLink = $('#hotline-number-link').attr('href')
	const updateLink =
		phoneLink.split(',')[1] == 'undefined' ? phoneLink : phoneLink.split(',')[0]

	$('#hotline-number-link').attr('href', updateLink)
}

export function scrollToTop() {
	// $('html,body').animate({ scrollTop: 0 }, '100')
	window.scrollTo(0, 0)
}

export function emptyVoucherForm() {
	$('#add-promo-code-popup').modal('hide')
	var promoCodeErrorMsgHolder = $('#error-msg-holder-in-popup')
	var promoCodeSuccessMsgHolder = $('#success-msg-holder-in-popup')
	promoCodeErrorMsgHolder.empty()
	promoCodeSuccessMsgHolder.empty()
	$('textarea[name="couponCode"]').val('')
	// window.location.reload()
	if (voucherIsValid) {
		window.location.reload()
	}
}

function rejectSubmitAction(data) {
	return new Promise((resolve, reject) => {
		const promoCodeErrorMsgHolder = $('#error-msg-holder-in-popup')
		const promoCodeSuccessMsgHolder = $('#success-msg-holder-in-popup')
		promoCodeErrorMsgHolder.empty()
		const errorMsg = data['0'].error
		const successMsg = data['0'].general

		$.each(errorMsg, function (key, value) {
			const errorMsgHtml = '<li>' + value + '</li>'
			promoCodeErrorMsgHolder.append(errorMsgHtml)
		})

		$.each(successMsg, function (key, value) {
			const successMsgHtml = '<li>' + value + '</li>'
			promoCodeSuccessMsgHolder.append(successMsgHtml)
			console.log('successMsg.length is ' + Object.keys(successMsg))
		})

		if (Object.keys(successMsg).length > 0) {
			voucherIsValid = true
			console.log('successMsg.length is ? ' + Object.keys(successMsg) > 0)

			$('#apply-promo-code-btn').addClass('disabled')
			resolve()
		} else {
			voucherIsValid = false
			$('#apply-promo-code-btn').removeClass('disabled')
			reject()
		}
	})
}

function postVoucherForm() {
	$('#promo-code-loading').show()
	return new Promise((resolve, reject) => {
		const voucherForm = $('#promo-code-voucher-form').serialize()
		$.post(
			'/store/checkout',
			voucherForm + '&ajax=1',
			(data, textStatus, xhr) => {
				if (data.status === 1) {
					voucherIsValid = true
					console.log('status 1 successMsg !!!')
					resolve()
				} else {
					rejectSubmitAction(data).then(
						() => {
							// fulfillment
							scrollToTop()
							$('#promo-code-loading').hide()
							$('#cart-msg-holder').show()

							console.log('status 0 successMsg !!!')
						},
						() => {
							// rejection
							scrollToTop()
							$('#promo-code-loading').hide()
							$('#cart-msg-holder').show()
							console.log('i am errorMsg !!!')
						},
					)
				}
			},
			'json',
		)
	})
}

function submitVoucher() {
	postVoucherForm().then(
		() => {
			if (voucherIsValid) {
				setCookie('couponApplied', true, 1, '')
			} else {
				setCookie('couponApplied', false, 1, '')
			}

			window.location.href = '/store/checkout'
		},
		() => {
			// rejection
			console.log('errorMsg')
		}
	)
}

export function addVoucher() {
	if ($('input[name=couponCode]').val() !== '') {
		// addLoadingEffect()
		submitVoucher()
	}
}

export function disableOuibounce() {
	if (enableExitIntend) {
		if (getCookie('viewedOuibounceModal') == '') {
			window._ouibounce.disable()
			window.viewedOuibounceModal = true
			console.log('window._ouibounce is disable')
		}
	}
}

export function enableOuibounce() {
	if (enableExitIntend) {
		if (window.viewedOuibounceModal) {
			eraseCookie('viewedOuibounceModal')
			exitIntent()
			window.viewedOuibounceModal = false
			console.log('window._ouibounce is enable')
		}
	}
}

export function disableOuibounceForNormal() {
	if (window._ouibounce) {
		window._ouibounce.disable()
		window.disabledOuibounce = true
		console.log('window._ouibounce is disable')
	}
}

export function enableOuibounceForNormal() {
	if (window.enableExitIntend) {
		if (window.disabledOuibounce) {
			eraseCookie('viewedOuibounceModal')
			window.exitIntent()
			window.disabledOuibounce = false
			console.log('window._ouibounce is enable')
		}
	}
}

export function printOrderSummary() {
	$('.printable').printThis({
		printDelay: 3600,
	})
}

export function navigateToPage(schedPage, eventPage) {
	const nextURL = getNavigationURL(schedPage, eventPage)
	window.location.href = '/' + nextURL
}

export function navigateToPage2025(baseSlug, schedule, choice, saveInfo) {
	const nextURL = getNavigationURL2025(baseSlug, schedule, choice, saveInfo)
	window.location.href = '/' + nextURL
}

export function getNavigationURL(schedPage, eventPage) {
	let scheduleEid = ''
	let thisEventPage = eventPage

	if (!schedPage && !eventPage) {
		schedPage = '/choice/best-available'
	}
	if (!eventPage) {
		thisEventPage = 'event/view/view/schedule/'
	}
	if (schedPage && !eventPage) {
		scheduleEid = getCookie('scheduleEid') || myvars.scheduleEid
	}
	if (schedPage === '/choice/seating-chart') {
		saveInfoToCookie()
	}


	// If leaving checkout page to new seating chart, save the customer info. --ap 4/1/21
	if (schedPage.includes('sc/1')) {
		saveInfoToCookie()
	}

	return thisEventPage + scheduleEid + schedPage
}

// a refactor of navigation url to support
// event/view/view/schedule/Tqr2K9IFsag/choice/seating-chart
// baseSlug = event/view/view/schedule
// schedule = Tqr2K9IFsag
// choice = /choice/best-available
export function getNavigationURL2025(baseSlug, schedule, choice, saveInfo) {
	//init defaults
	if (!baseSlug)
		baseSlug = 'event/view/view/schedule/'
	if (!schedule) {
		schedule = getCookie('scheduleEid') || myvars.scheduleEid
		if (!schedule) {
			return ""; //return to homepage if no schedule value
		}
	}
	if (!choice) {
		var choiceCookie = getCookie('choiceSeat')
		if (choiceCookie) {
			if (choiceCookie === "fromSeatingChart")
				choice = '/choice/seating-chart'
			if (choiceCookie === "fromBundle")
				choice = '/choice/bundle'
			if (choiceCookie === "fromBestAvailable")
				choice = '/choice/best-available'
			if (choiceCookie === "fromSC")
				choice = '/choice/seating-chart/sc/1'
			if (choiceCookie === "fromGift")
				choice = '/choice/gift'
		}
		else
			choice = '/choice/seating-chart'
	}

	if (saveInfo && $('[name="order-payment-form"] #firstName').val().trim() !== '') {
		saveInfoToCookie()
	}
	return baseSlug + schedule + choice
}

export function getTicketEid() {
	window.seatsInCartObj = {}
	const ticketItem = $('[data-each="ticket-item-count"]')
	const ticketLength = ticketItem.length
	for (let i = 0; i < ticketLength; i++) {
		const seatEid = $(ticketItem[i]).data('seatEid')
		const ticketEid = $(ticketItem[i]).data('ticketEid')
		window.seatsInCartObj[seatEid] = ticketEid
	}
}

export function youtubePlayerCode(divName, youtubeID, playlistID) {
	var playlistMark = playlistID ? '?playlist=' + playlistID + '&amp;' : '?'
	return (
		'<div class="embed-responsive embed-responsive-16by9"><iframe id="' +
		divName +
		'" class="embed-responsive-item" src="//www.youtube.com/embed/' +
		youtubeID +
		playlistMark +
		'rel=0&amp;autoplay=1&amp;autohide=1&amp;showinfo=0&amp;enablejsapi=1" frameborder="0" allowfullscreen></iframe></div>'
	)
}

export function videoJsCode(divName, videoLink) {
	return `
	<div class='VideoWrapper embed-responsive embed-responsive-16by9'>
		<video
				class='video-js vjs-theme-city vjs-fluid embed-responsive-item'
				controls autoplay
				preload='auto'
				width='640'
				height='264'
				data-setup='{}'
				controlslist='nodownload'
			>
				<source src='${videoLink}' type='video/mp4' />
			</video>
  </div>
`
}

export function addBlankDiv(className) {
	if ($('.' + className).length === 0) {
		var div = document.createElement('div')
		div.className = className
		return document.body.appendChild(div)
	}
}

export function barbaMarkup(barbaName) {
	$('body').attr('data-barba-name', barbaName)
}

export function initValidation(
	form,
	rulesObj,
	messagesObj,
	checkEmail = false
) {
	$.validator.setDefaults({
		debug: false,
	})

	const validator = $(form).validate()
	validator.destroy()
	$(form).validate({
		debug: false,
		rules: rulesObj,
		messages: messagesObj,
		errorElement: 'em',
		errorPlacement: function (error, element) {
			// Add the `help-block` class to the error element
			error.addClass('help-block')

			if (element.prop('type') === 'checkbox') {
				error.insertAfter(element.parent('label'))
			} else {
				error.insertAfter(element)
			}
		},
		highlight: function (element, errorClass, validClass) {
			$(element)
				.parents('.address-form-item')
				.addClass('has-error')
				.removeClass('has-success')
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element)
				.parents('.address-form-item')
				.addClass('has-success')
				.removeClass('has-error')
		},
		onfocusout: function (element) {
			this.element(element) // <- "eager validation"
		},
		focusCleanup: true,
	})
	if (checkEmail) {
		$.validator.methods.email = function (value, element) {
			let valid = true
			const regex =
				/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			const emails = value.replace(/\s/g, '').split(',')
			for (let i = 0; i < emails.length; i++) {
				if (emails[i] === '' || !regex.test(emails[i])) {
					valid = false
				}
			}

			return valid
			// return (
			// 	this.optional(element) ||
			// 	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
			// 		value.replace(/\s/g,'').split(',')
			// 	)
			// )
		}
	}
}

export function addProductToCart(eid, price) {
	var userDetecter = $('[data-php-convert-to-js]')
	var modelhelper = userDetecter.data('modelhelper') == 1

	if (modelhelper) {
		if (
			confirm(
				'This will add the product to your cart. Your page will refresh. You will need to reenter your delivery, recipient, and payment information.'
			)
		) {
			var quantity = $('#quantity').val() ? $('#quantity').val() : 1
			var url = "/store/shopping-cart/add/item/" + eid + "/quantity/" + quantity + "/price/" + price;
			self.location = url
		}
	} else {
		var quantity = $('#quantity').val() ? $('#quantity').val() : 1
		var url = '/store/shopping-cart/add/item/' + eid + '/quantity/' + quantity + "/price/" + price;
		self.location = url
	}
}

export function _ajaxGetContent(elem, url, callBack) {
	return new Promise((resolve, reject) => {
		// if ($(elem).children().length === 0) {
		$.ajax({
			url,
			type: 'GET',
			dataType: 'html',
			cache: false,
			timeout: 60000,
			success(data, textStatus, xhr) {
				$(elem).html(data)
				resolve()
			},
			error(jqXHR, textStatus, errorThrown) {
				// if (textStatus == 'timeout') {
				// }

				reject()
			},
		})
		// } else {
		//  reject()
		// }
	}).then(
		() => {
			if (callBack) {
				setTimeout(() => callBack(), 500)
			}
			// callBack
			// console.log('callBack!')
		},
		() => {
			console.log('reject()')
		}
	)
}

// Set/Reset and Cache Module elements
export function _setElements(that, selectors) {
	// Cache Elements into $el
	$.each(selectors, (i, obj) => {
		that[i] = $(obj)
	})
}

export function showSeatingChartHeader() {
	$('#mobile-select-event-schedule-block').insertAfter('.mobile-header-bottom')
}

export function ajaxCartMenu() {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/shared-misc/ajax-header-auth-section',
		}).done((html) => {
			$('#ajax-load-menu').html(html)
			resolve()
		})
	})
}

export async function ajaxCartNum() {
	return new Promise((resolve, _) => {
		$.ajax({
			url: '/shared-misc/ajax-cart-num',
		}).done((data) => {
			window.num = Number(data)
			resolve(window.num)
		})
	})
}

export async function ajaxLoadMenu() {
	await ajaxCartMenu()
	const cartNum = await ajaxCartNum()
}

export function upatePopupScheduleList(scheduleItem, choice) {
	$.each(scheduleItem, function (index, val) {
		var urlstring = $(this).attr('href')
		var originalUrl =
			urlstring.split('/choice/')[1] == 'undefined'
				? urlstring
				: urlstring.split('/choice/')[0]

		$(this).attr('href', `${originalUrl}/choice/${choice}`)
	})
}

export function addLoadingEffect() {
	return new Promise((resolve, _) => {
		// if (!btnLoading) {
		document.querySelector('body').classList.add('is-loading')
		window.scrollTo(0, 0)

		$('#loading-modal')
			.modal({
				show: true,
				keyboard: false,
				backdrop: 'static',
			})
			.on('shown.bs.modal', (e) => {
				e.target.classList.add('is-active')
			})
			.on('hidden.bs.modal', (e) => {
				e.target.classList.remove('is-active')
				document.querySelector('body').classList.remove('is-loading')
			})

		resolve()
	})
}

export function hideLoadingEffect() {
	$('#loading-modal').modal('hide')
}

export function addLoadingForNormalLink() {
	return $.each($('.active-loading'), function (i, v) {
		const hrefLink = $(v).attr('data-href')
		return $(v).click(function (e) {
			e.preventDefault()
			return addLoadingEffect().then(function () {
				return new Promise(function (resolve, reject) {
					setTimeout(function () {
						return (window.location.href = hrefLink)
					}, 600)
					return resolve()
				})
			})
		})
	})
}

export function saveScheduleEidToCookie(cvalue) {
	setCookie('scheduleEid', cvalue, 365, '')
}

export function saveSeatingChartSize(bestAvailablePage) {
	const seatingChartSizeObj = {}
	const seatingChartWidth = bestAvailablePage
		? _query('#best-available').getAttribute('data-map-width')
		: window.chartVars.chartWidth

	const seatingChartHeight = bestAvailablePage
		? _query('#best-available').getAttribute('data-map-height')
		: window.chartVars.chartHeight
	seatingChartSizeObj.width = window.myvars.showVertical && !isMobileDevice ? seatingChartHeight : seatingChartWidth
	seatingChartSizeObj.height =
		window.myvars.showVertical && !isMobileDevice
			? seatingChartWidth
			: seatingChartHeight
	// console.info('seatingChartSizeObj: ' + seatingChartSizeObj)
	bake_cookie('seatingChartSizeObj', seatingChartSizeObj, 1)
}

export function closeTriggerMenu(elm) {
	const fadeTarget = document.querySelector(elm)
	if (fadeTarget !== null) {
		// fadeTarget.style.setProperty('display', 'none')
		fadeTarget.classList.replace('fadeIn', 'fadeOut')

		fadeTarget.addEventListener('animationend', () => {
			fadeTarget.style.setProperty('display', 'none')
		})
	}
}

export function showElement(elm) {
	const fadeTarget = document.querySelector(elm)
	if (fadeTarget !== null) {
		fadeTarget.classList.add('animated', 'fadeIn', 'faster')
		fadeTarget.style.setProperty('display', 'block')
		// fadeTarget.addEventListener('animationend', () => {
		//   fadeTarget.style.setProperty('display', 'block')
		// })
	}
}

window.closeTriggerMenu = closeTriggerMenu
window.showElement = showElement
window.showLoading = addLoadingEffect
window.addLoadingEffect = addLoadingEffect
window.hideLoading = hideLoadingEffect
window.hideLoadingEffect = hideLoadingEffect
window.addLoadingForNormalLink = addLoadingForNormalLink
window.enableOuibounceForNormal = enableOuibounceForNormal
window.removeTicketFromCart = removeTicketFromCart
// window.removeGiftCardFromCart = removeGiftCardFromCart
window.scrollToTop = scrollToTop
window.emptyVoucherForm = emptyVoucherForm
window.addVoucher = addVoucher
window.barbaMarkup = barbaMarkup
window.ajaxCartNum = ajaxCartNum
window.getTicketEid = getTicketEid
window.emptyCartNum = emptyCartNum
window.emptyCartNum2025 = emptyCartNum2025
window.navigateToPage = navigateToPage
window.navigateToPage2025 = navigateToPage2025
window.addProductToCart = addProductToCart
window.disableOuibounce = disableOuibounce
window.enableOuibounce = enableOuibounce
window.emptyCartSimple = emptyCartSimple
window.emptyCartTickets = emptyCartTickets
window.printOrderSummary = printOrderSummary
window.enableOuibounce = enableOuibounce
// window.validateAddressActions = validateAddressActions
window.setStyles = setStyles
window.upatePhoneLink = upatePhoneLink
window.addCustomTooltip = addCustomTooltip
window.addCustomTooltipOnce = addCustomTooltipOnce
